import {getData} from './GetData';

const MenuDataService = () => {
  let language = process.env.RAZZLE_LANGUAGE || window.env.RAZZLE_LANGUAGE;
  language = language.trim();
  const country = language.slice(language.length - 2, language.length).toUpperCase();

  switch (country) {
    case 'AR':
      return getData({url: `https://www.agrofy.com.ar/main-menu/list`}).catch(()=>{return []});
    case 'BR':
      return getData({url: `https://www.agrofy.com.br/main-menu/list`}).catch(()=>{return []});
  }
};

export default MenuDataService;
